
  <table class="table-new-design" style="border-collapse:collapse !important; ">
    <thead>
      <tr>
        <th>ID</th>
        <th>Request Title</th>
        <th>Scope</th>
        <th>Status</th>
      </tr>
    </thead>
    <tbody>      
      <tr *ngFor="let request of requests">
        <td>
          <a href="" class="font-color-navy" target="_blank" style="cursor:pointer;" title="View Request Details">{{request.id}}</a>
        </td>
        <td>{{request.title}}</td>
        <td>
          <span>{{request.relatedScope}}</span>
        </td>
        <td>
          {{request.state}}
        </td>
      </tr>      
    </tbody>
  </table>

